module.exports = __webpack_public_path__ + "img/6fbcf9a7ca655ec85c3eed791e1a51d0.ffe569dd.jpg";